import {FlexSuiteStatistics} from '../../../../components/FlexSuiteStatistics'
import type {TextItem} from '../../../../types'

type Props = {
  stats?: TextItem[]
}

export function OutroStats({stats}: Props) {
  return <FlexSuiteStatistics stats={stats} />
}
